import { useEffect, useMemo, useRef, useState } from "react";
import usePosts from "../usePosts";
import { TABS } from "./Tabs";
import { PostCard } from "./PostCard";
import Spinner from "../../../../components/Spinners";
import { api } from "../../../../helpers/api";
import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { ConfirmDeletePost } from "./ConfirmDeletePost";
import { ShowToast } from "../../../../components/toast";

export function LikedPosts({ user, refresh, type }) {
  const queryClient = useQueryClient();
  const loadMoreRef = useRef<any>(null);
  const [deletePostConfirmation, setDeletePostConfirmation] =
    useState<any>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<any>(false);
  const [isDeletingPost, setIsDeletingPost] = useState(false);

  const fetchUsers = async ({ pageParam }) => {
    const API = type === TABS.LIKED ? api.getLikedPosts : api.getSavedPosts;
    const res = await API({
      userId: user?.id,
      page: pageParam,
      limit: 10,
    });
    console.log("res", res);
    return res?.data || [];
  };
  const queryName =
    type === TABS.LIKED ? "infinite-liked-posts" : "infinite-bookmarked-posts";
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: [queryName, user?.id],
    queryFn: fetchUsers,
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages, pageParam) => {
      console.log(lastPage);
      if (lastPage.length < 10) return null;
      return pageParam + 1;
    },
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      {
        root: null,
        rootMargin: "20px",
        threshold: 1.0,
      }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const posts = useMemo(() => {
    if (data) {
      // Combine pages into one array
      const newData = data.pages.flatMap((page) => page);
      // Set the combined data into the table data state
      return newData;
    }
  }, [data]);

  const handleDelete = () => {
    console.log("deletePostConfirmation", deletePostConfirmation, type);
    // setIsDeletingPost(true);
    // api
    //   .deletePost(deletePostConfirmation?.id)
    //   .then(() => {
    //     ShowToast({
    //       message: "Post deleted successfully",
    //       type: "success",
    //     });
    //     refresh();
    //     setDeletePostConfirmation(false);
    //     queryClient.invalidateQueries({ queryKey: ["posts"] });

    //     setIsDeletingPost(false);
    //   })
    //   .catch(() => {
    //     ShowToast({
    //       message: "Failed to delete post",
    //       type: "error",
    //     });
    //     setIsDeletingPost(false);
    //   });
  };

  console.log(data);
  return (
    <div className="mt-5 flex mx-7 px-3 pb-3 tall:max-h-[575px] max-h-[600px] overflow-auto flex-wrap">
      {!isLoading && posts?.length === 0 && <div>No posts found</div>}
      {/** divide posts in two parts one is odd and second is even */}
      <div className="flex flex-col gap-4 flex-[50%] max-w-[50%] pr-2">
        {posts?.map((post, index) => {
          if (index % 2 === 0) {
            return (
              <PostCard
                user={user}
                key={post.id}
                type={type}
                post={post}
                onPostDelete={() => {
                  setDeletePostConfirmation(post);
                }}
                refresh={() => {
                  refetch();
                  refresh();
                }}
              />
            );
          }
          return null;
        })}
      </div>
      <div className="flex flex-col gap-4 flex-[50%] max-w-[50%] pl-2">
        {posts?.map((post, index) => {
          if (index % 2 !== 0) {
            return (
              <PostCard
                user={user}
                key={post.id}
                type={TABS.POSTS}
                post={post}
                refresh={() => {
                  refetch();
                  refresh();
                }}
              />
            );
          }
          return null;
        })}
      </div>
      {/* {(posts || [])?.map((post: any) => (
        <PostCard key={post.id} type={TABS.POSTS} post={post} />
      ))} */}
      {isLoading && (
        <div className="flex justify-center [&_svg]:text-slate-900">
          <Spinner />
        </div>
      )}

      <div className="">
        <button
          type="button"
          onClick={() => fetchNextPage()}
          disabled={!hasNextPage || isFetchingNextPage}
          ref={loadMoreRef}
        >
          {/* {isFetchingNextPage
                ? "Loading more..."
                : hasNextPage
                ? "Load More"
                : "Nothing more to load"} */}
        </button>
      </div>

      {deletePostConfirmation.id && (
        <ConfirmDeletePost
          onClose={() => setDeletePostConfirmation(false)}
          refetch={refresh}
          postId={deletePostConfirmation.id}
          onDelete={() => handleDelete()}
          isLoading={isDeletingPost}
        />
      )}
    </div>
  );
}
